export default {
  newsnotice: {
    searchPlaceholder: '输入新闻标题进行搜索',
    title: '新增新闻公告',
    subject: '新闻标题',
    subjectplaceholder: '请输入新闻标题...',
    contentKeyword: '内容关键词',
    fileNo: '附件',
    content: '新闻内容',
    published: ['暂不发布', '发布'],
    ispublish: '是否发布',
    publish: ['草稿', '已发布', '已取消'],
    publishnow: '立即发布',
    publishcancel: '取消发布',
    upddate: '更新时间',
    adddate: '创建时间',
    requiredcontent: '请输入新闻内容',
    submit: '立即发布',
    save: '存为草稿',
    confirmpublish: '是否发布',
    confirmcancel: '是否取消发布',
    dateRange: '创建日期'
  }
}
